<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Cultural Events</h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
			alt="GHRSCF" />
	</div>
</section>
<section class="section section-sm culture-events section-banner-bg-1">
	<div class="container">
		<div class="row text-justify">

			<div class="col-md-12">
				<p>
					CULTURE in the broadest understanding of the term means the totality of all spiritual, material,
					intellectual and emotional features of a society or social group and alongside art and literature
					includes also the way of life, ways of co-existence, systems of values, traditions and views.</p>
				<p>When assessing the role of culture in the life of each state and community, it is important not to
					impose limits upon it, judging about it only as to its as to its applicability, but to foster the
					development of each individual’s creative potential and participation in culture processes.</p>
				<p>Culture not only brings social cohesion to society, but also educates, enriching the process of
					life-long education with new informal possibilities for the growth of personality.</p>

			</div>

			<div class="widget_title inner-title mt-3">
				<h4> OBJECTIVES OF THE CONCEPT </h4>
			</div>
			<ul class="list-style list-style1">
				<li> Providing the right forms of support and recognition for Athletes Sports persons and individual
					artists is an important element of this Foundation.</li>
				<li> This includes pathways from school and university to work, opportunities for emerging sports
					persons & artists to get a foothold, opportunities for mid-career people to consolidate and
					recognition of the lifetime contribution of eminent in all fields.</li>
				<li> All our activities aim to increase Sports, Arts and culture professionals’ interaction between RGI
					and the target population. (This is grass-roots work almost at the level of individuals, and its
					effects may not be visible for years but will provide the great foundation for the future to come.)
				</li>
				<li> All the institute’s projects aim to increase the professional competence. It depends on the project
					whether this increasing competence relates to content (e.g. artistic work) or career development
					(networks, country-specific sector knowledge).</li>
				<li> To provide learning experience to all.</li>
				<li> To put new emphasis and to define the directions of strategic development within the development of
					Indian Sports and Culture policy.</li>
			</ul>
		</div>
		<div class="border-line-sm"></div>
		<div class="row justify-content-center row-cols-1 row-cols-lg-3 align-items-center">
			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-2.webp"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">
						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span> April 2025</span>
						</div>
						<h3 class="h5 card-title">Jhankar' Lavani Competition Celebrates Folk Culture </h3>
						<p class="card-text">
							Raisoni Foundation, in association with Lokmat Sakhi, successfully organized the ‘Jhankar’
							Lavani Competition. </p>

						<div class="d-flex justify-content-between">
							<a routerLink="/zankar-lavani" class="cmn-button">
								Read More
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-3.webp"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">
						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span> August 2025</span>
						</div>
						<h3 class="h5 card-title">एक शाम गीतों के नाम </h3>
						<p class="card-text">
							Memories bloomed, and hearts sang together.
							From timeless classics to soulful tunes, the event brought generations together through the
							magic of music.

						</p>

						<div class="d-flex justify-content-between">
							<a routerLink="/ek-sham-geeto-ke-naam" class="cmn-button">
								Read More

							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/dance-nagpur.avif"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">
						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span> June 2024</span>
						</div>
						<h3 class="h5 card-title"> Dance Nagpur Dance - Final Showdown </h3>
						<p class="card-text">Relive the magic of Dance Nagpur Dance 2024! Catch every spectacular
							moment from the grand finale!
						</p>

						<div class="d-flex justify-content-between">
							<a routerLink="/register-dance-event" class="cmn-button">
								Read More

							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/jhipri.avif"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">
						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span>2024</span>
						</div>
						<h3 class="h5 card-title">Jhipru and Chimnayano</h3>
						<p class="card-text">'झिपरू' हे बालनाट्य आणि 'या चिमण्यांनो' हा बालगीतांचा कार्यक्रम आयोजित
							करण्यात आला होता</p>
						<div class="d-flex justify-content-between">
							<a routerLink="/jhipru-and-chimnayano" class="cmn-button">
								Read More

							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/karandak.avif"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">
						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span> 2024</span>
						</div>
						<h3 class="h5 card-title">Karandak Auditions</h3>
						<p class="card-text">जी. एच. रायसोनी स्पोर्ट्स अँड कल्चरल फाउंडेशनच्या वतीने आयोजित जी.एच.
							रायसोनी करंडक राज्यस्तरीय आंतरमहाविद्यालयीन एकांकिका स्पर्धेच्या प्राथमिक फेरीची नांदी झाली
						</p>
						<div class="d-flex justify-content-between">
							<a routerLink="/karandak-auditions" class="cmn-button">
								Read More

							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/dnd.jpg"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">
						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span> 2023</span>
						</div>
						<h3 class="h5 card-title">Dance Nagpur Dance</h3>
						<p class="card-text"><strong>Center :</strong>Jaripatka ,Wadi, Manish Nagar, Mankapur,
							Mangalwari, Sadar,
							Hingna T Point, Wardhaman Nagar Nagpur.</p>
						<div class="d-flex justify-content-between">
							<a routerLink="/register-dance-event" class="cmn-button">
								Read More

							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/musical-night.webp"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">
						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span> 2022-23</span>
						</div>
						<h3 class="h5 card-title">Musical Rejuvenation</h3>
						<p class="card-text">Music has been an integral part of human life for centuries, serving
							various purposes
							such as entertainment</p>
						<div class="d-flex justify-content-between">
							<a routerLink="/musical-rejuvenation" class="cmn-button">
								Read More

							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cult-1.webp"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">
						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span> 2020-21</span>
						</div>
						<h3 class="h5 card-title">Classical Conclave</h3>
						<p class="card-text">Classical Conclave is an initiative of G H Raisoni Sports and Cultural
							Foundation</p>
						<div class="d-flex justify-content-between">
							<a routerLink="/classic-conclave" class="cmn-button">
								Read More

							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cult-3.webp"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">
						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span> 2021</span>
						</div>
						<h3 class="h5 card-title">Shivaji Mahotsav</h3>
						<p class="card-text">The life of one of the greatest warrior and ruler of his time, Maharaja
							Shivaji Rao. </p>
						<div class="d-flex justify-content-between">
							<a routerLink="/shivaji-mahotsav" class="cmn-button">
								Read More

							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cult-6.webp"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">

						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span> 14 January 2021</span>
						</div>
						<h3 class="h5 card-title">Kite Festival</h3>
						<p class="card-text">Every January with the reason of Makar Sankranti fun happens in RGI.</p>
						<div class="d-flex justify-content-between">
							<a routerLink="/kite-festival" class="cmn-button">
								Read More

							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cult-2.webp"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">
						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span> 2019</span>
						</div>
						<h3 class="h5 card-title">Ganesha Utsava</h3>
						<p class="card-text">India is a land of festival. It is a land of religious inclination. It is
							the land of cultural integrity. </p>
						<div class="d-flex justify-content-between">
							<a routerLink="/ganesha-utsava" class="cmn-button">
								Read More

							</a>
						</div>
					</div>
				</div>
			</div>


			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cult-4.webp"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">
						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span> 2019</span>
						</div>
						<h3 class="h5 card-title">Dance City Dance</h3>
						<p class="card-text">Dance City Dance is an initiative of G H Raisoni Sports and Cultural
							Foundation</p>
						<div class="d-flex justify-content-between">
							<a routerLink="/dance-city-dance" class="cmn-button">
								Read More

							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col">
				<div class="card border-light shadow-soft">
					<div class="card-header p-3 shadow-inset image-effect-1">
						<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cult-5.webp"
							class="card-img-top rounded" alt="GHRSCF">
					</div>
					<div class="card-body pt-2">
						<div class="event-date">
							<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
								alt="GHRSCF" />
							<span> 2019</span>
						</div>
						<h3 class="h5 card-title">Dhamaal Dandiya</h3>
						<p class="card-text">We, at The Raisoni Group of Institutions have the most accomplished,
							outstanding </p>
						<div class="d-flex justify-content-between">
							<a routerLink="/dhamaal-dandiya" class="cmn-button">
								Read More

							</a>
						</div>
					</div>
				</div>
			</div>



		</div>
	</div>
</section>
